// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-pick-my-picks-navigation {
  width: 100%;
  background-color: #E8E8E8;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 2px solid #002129;
}
.quick-pick-my-picks-navigation__content {
  margin: 0 auto;
  width: 310px;
}
@media (min-width: 600px) {
  .quick-pick-my-picks-navigation__content {
    width: 467px;
  }
}
.quick-pick-my-picks-navigation__game-date-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.quick-pick-my-picks-navigation__icon {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
.quick-pick-my-picks-navigation__icon:hover, .quick-pick-my-picks-navigation__icon:focus {
  outline: none; /* Remove the thin outline */
}
.quick-pick-my-picks-navigation__icon:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.quick-pick-my-picks-navigation__icon svg {
  font-size: 24px;
  color: #002129;
}
.quick-pick-my-picks-navigation__icon svg:hover, .quick-pick-my-picks-navigation__icon svg:focus {
  outline: none; /* Remove the thin outline on the SVG icons */
}
.quick-pick-my-picks-navigation__week-select-container {
  display: flex;
  align-items: center;
}
.quick-pick-my-picks-navigation__week-select {
  color: white;
}
.quick-pick-my-picks-navigation__week-select:hover, .quick-pick-my-picks-navigation__week-select:focus {
  outline: none; /* Remove the outline around the select */
  border-color: transparent; /* Remove any border */
}
.quick-pick-my-picks-navigation__week-select .MuiSelect-select {
  color: #002129;
  font-size: 24px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.quick-pick-my-picks-navigation__week-select .MuiOutlinedInput-notchedOutline {
  border-color: transparent;
}
.quick-pick-my-picks-navigation__week-select .MuiSvgIcon-root {
  color: #002129;
  font-size: 32px;
  margin-left: 8px;
  margin-right: -8px;
}
.quick-pick-my-picks-navigation__week-select .MuiMenuItem-root {
  color: #002129;
}
.quick-pick-my-picks-navigation__week-select .MuiMenuItem-root.Mui-selected {
  color: #002129;
  background-color: #002129;
}`, "",{"version":3,"sources":["webpack://./src/components/QuickPickGames/MyPicks/QuickPicksMyPicksNavBar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,gCAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;AACJ;AACI;EAJF;IAKI,YAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAJ;AAEI;EACE,aAAA,EAAA,4BAAA;AAAN;AAGI;EACE,YAAA;EACA,mBAAA;AADN;AAII;EACE,eAAA;EACA,cAAA;AAFN;AAIM;EACE,aAAA,EAAA,6CAAA;AAFR;AAOE;EACE,aAAA;EACA,mBAAA;AALJ;AAQE;EACE,YAAA;AANJ;AAQI;EACE,aAAA,EAAA,yCAAA;EACA,yBAAA,EAAA,sBAAA;AANN;AASI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAPN;AAUI;EACE,yBAAA;AARN;AAWI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AATN;AAYI;EACE,cAAA;AAVN;AAYM;EACE,cAAA;EACA,yBAAA;AAVR","sourcesContent":[".quick-pick-my-picks-navigation {\n  width: 100%;\n  background-color: #E8E8E8;\n  padding: 0 16px;\n  box-sizing: border-box;\n  border-bottom: 2px solid #002129;\n\n  &__content {\n    margin: 0 auto;\n    width: 310px;\n\n    @media (min-width: 600px) {\n      width: 467px;\n    }\n  }\n\n  &__game-date-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  &__icon {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n\n    &:hover, &:focus {\n      outline: none; /* Remove the thin outline */\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    svg {\n      font-size: 24px;\n      color: #002129;\n\n      &:hover, &:focus {\n        outline: none; /* Remove the thin outline on the SVG icons */\n      }\n    }\n  }\n\n  &__week-select-container {\n    display: flex;\n    align-items: center;\n  }\n\n  &__week-select {\n    color: white;\n\n    &:hover, &:focus {\n      outline: none; /* Remove the outline around the select */\n      border-color: transparent; /* Remove any border */\n    }\n\n    .MuiSelect-select {\n      color: #002129;\n      font-size: 24px;\n      font-weight: 500;\n      display: flex;\n      align-items: center;\n    }\n\n    .MuiOutlinedInput-notchedOutline {\n      border-color: transparent;\n    }\n\n    .MuiSvgIcon-root {\n      color: #002129;\n      font-size: 32px;\n      margin-left: 8px;\n      margin-right: -8px;\n    }\n\n    .MuiMenuItem-root {\n      color: #002129;\n\n      &.Mui-selected {\n        color: #002129;\n        background-color: #002129;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
